import { ComponentInternalInstance, Ref, ref, VNode } from "vue";
import App from "@/App.vue";
import Tools from "@/ts/Tools";
import ad_account from "./vo/dbvo/ad_account";
import MQTTService from "./MQTTService";
import Config from "./Config";
import WebApiService from "./api/WebApiService";
import { ColorEnum, ResourceTypeEnum } from "./SuperEnum";
import TTSPlayer from "./TTSPlayer";
import GeneralObjVO from "./vo/templates/GeneralObjVO";
import AnimationBaseVO from "./vo/animations/AnimationBaseVO";
import ad_resources from "./vo/dbvo/ad_resources";
import GuideMenuButtonVO from "./vo/GuideMenuButtonVO";

export type AnimType = {
    AnimKey: string,
    AnimName: string,
    AnimIcon: string,
    Anim: new () => AnimationBaseVO
};

/**
 * 调用ANDROID讯息
 */
export type AndroidInterface = {
    /**
     * 扫码
     * @returns 
     */
    ScanH5toAndroid: () => void,
    /**
     * 获取定位位置
     * @returns 
     */
    LocationH5toAndroid: () => void,
    /**
     * 获取唯一标识
     * @returns 
     */
    UicH5toAndroid: () => string,
    /**
     * 
     * @param type 
     * @returns
     */
    GetAlbumPaths: (page: number, pageSize: number, type: 1 | 2) => string,
    /**
     * 添加资源
     * @param authKey 
     * @param filePath 
     * @param resourceType 
     * @param resourceTypeID 
     * @returns 
     */
    AddResource: (authKey: string, filePath: string, resourceType: ResourceTypeEnum, resourceTypeID: number) => void
};

export type LoginCheckFlag = "DEVICE_LOGIN" | "DEVICE_QR" | "ACCOUNT_LOGIN" | "ACCOUNT_REFRESH_TOKEN" | "ACCOUNT_SUCCESS";

/**
 * 全局
 */
export default class Global {
    /**
     * 应用APP
     */
    public static app: InstanceType<typeof App> | null = null;


    /**
     * 是否是APP
     */
    public static get IsApp(): boolean {
        // 获取当前的用户代理字符串
        const userAgent = navigator.userAgent;
        // 判断是否包含自定义标识
        const isApp = userAgent.includes('AveritsementApp/1.0');
        return isApp;
    }

    private static _GeneralObj: Ref<GeneralObjVO> | null = null;

    /**
     * Android对象
     */
    public static get AndroidInterface(): AndroidInterface {
        return (globalThis as any).AndroidInterface;
    }

    /**
     * 获取
     */
    public static get GeneralObj(): Ref<GeneralObjVO> {
        if (this._GeneralObj == null)
            this._GeneralObj = ref(new GeneralObjVO()) as any;
        Object.setPrototypeOf(this._GeneralObj?.value, GeneralObjVO.prototype);
        return this._GeneralObj!;
    }

    /**
     * 设置
     */
    public static set GeneralObj(v: Ref<GeneralObjVO>) {
        this._GeneralObj = v;
    }



    public static LastTime: number = 0;
    public static FrameInterval: number = 1000 / 60;  // 设定每帧的时间间隔（60 FPS）
    /**
     * 预加载毫秒数
     */
    public static PreloadTime: number = 3000; //预加载毫秒数
    /**
     * API接口
     */
    public static api: WebApiService = new WebApiService();
    public static TtsPlayer: TTSPlayer = new TTSPlayer();
    private static _jwtToken = ref<string>("");
    private static _refreshToken = ref<string>(""); //刷新Token

    /**
     *  MQTT服务
     */
    public static mqttService: MQTTService = new MQTTService();


    /**
     * 扫描回调事件
     */
    public static OnScanAndroidtoH5: ((content: string) => void) | null = null;

    /**
     * 去扫码
     * @param onCallBack 
     */
    public static ToScanH5toAndroid(onCallBack: (content: string) => void) {
        this.OnScanAndroidtoH5 = onCallBack;
        Global.AndroidInterface?.ScanH5toAndroid && Global.AndroidInterface?.ScanH5toAndroid();
    }

    /**
     * 是否为设备
     */
    public static get IsDevice(): boolean {
        const d = this.DeivceNumber;
        if (Tools.IsNotNull(d)) {
            let isManager = localStorage.getItem(`IsManager`);
            if (isManager == 'TRUE') {
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    }

    private static _deivceNumber: string = "";
    /**
     * 设备号
     */
    public static get DeivceNumber(): string {
        if (Tools.IsNotNull(this._deivceNumber))
            return this._deivceNumber;
        try {
            this._deivceNumber = this.AndroidInterface?.UicH5toAndroid() ?? "";
        }
        catch {

        }

        return this._deivceNumber;
    }

    /**
     * 设置是否为管理
     */
    public static set SetManager(v: boolean) {
        localStorage.setItem(`IsManager`, v ? "TRUE" : "FALSE");
    }



    /**
     * 广告机广告刷新签名
     */
    private static _DeviceAdRefreshSignature: string = "";


    /**
     * 广告机广告刷新签名
     */
    public static get DeviceAdRefreshSignature(): string {
        return this._DeviceAdRefreshSignature;
    }


    /**
     * 广告机广告刷新签名
     */
    public static set DeviceAdRefreshSignature(v: string) {
        Tools.ShowLog('更新广告机', `${v}`, ColorEnum.Info);
        this._DeviceAdRefreshSignature = v;
    }


    /**
     * 获取API的头部路径
     * @param action 
     */
    public static GetAPIUrl(action: string) {
        return `${Config.API_HOST}${action}`;
    }


    /**
     * 登录检查
     */
    private static async LoginCheckAsync(): Promise<LoginCheckFlag> {
        let jwtToken = this.JwtToken.value;
        let refreshToken = this.RefreshToken.value;
        if (Tools.IsNull(jwtToken) || Tools.IsNull(refreshToken)) {
            //直接选择登录
            if (this.IsDevice) {
                //检查是否存在这个设备
                if (!await Global.api.deviceApi.HasDeviceFromDeviceNumberAsync(Global.DeivceNumber)) {
                    return "DEVICE_QR";
                }
                return "DEVICE_LOGIN"; //设备登录
            }
            else {
                return "ACCOUNT_LOGIN"; //账号登录
            }
        }
        else {
            //选择刷新TOKEN
            if (this.IsDevice) {
                //检查是否存在这个设备
                if (!await Global.api.deviceApi.HasDeviceFromDeviceNumberAsync(Global.DeivceNumber)) {
                    return "DEVICE_QR";
                }
                return "DEVICE_LOGIN"; //设备登录
            }
            else {

                //检查TOKEN是否过期
                if (!this.JWTTokenEffective()) {
                    return "ACCOUNT_REFRESH_TOKEN"; //账号刷新
                }
                else {
                    return "ACCOUNT_SUCCESS";
                }
            }
        }
    }

    /**
     * 尝试登录
     */
    public static async TryToLoginAsync() {
        //#region 登录与认证

        let is_check_ok = false;
        do {
            let flag = await Global.LoginCheckAsync();
            switch (flag) {
                case "ACCOUNT_SUCCESS":
                    if (await this.ToConnectServerAsync())
                        is_check_ok = true;
                    break;
                case "ACCOUNT_LOGIN": //账号登录
                    Tools.GoTo("/login", true);
                    is_check_ok = true;
                    break;
                case "ACCOUNT_REFRESH_TOKEN": //账号状态刷新
                    if (!await Global.ToRefreshTokenAsync()) {
                        Global.JwtToken = ref("");
                        Global.RefreshToken = ref("");
                    }
                    else {
                        if (await this.ToConnectServerAsync())
                            is_check_ok = true;
                    }
                    break;
                case "DEVICE_LOGIN":  //设备登录
                    if (!await Global.api.globalApi.DeviceLoginAsync(Global.DeivceNumber)) {
                        Tools.AlertError(`设备:${Global.DeivceNumber}登录失败!`);
                        return;
                    }
                    else {
                        if (await this.ToConnectServerAsync()) {
                            is_check_ok = true;
                        }
                    }
                    break;
                case "DEVICE_QR": //设备二维码绑定
                    Tools.GoTo("/bind_device", true);
                    is_check_ok = true;
                    break;
            }
        }
        while (!is_check_ok);
        //#endregion
    }



    /**
     * 连接到服务器
     */
    public static async ToConnectServerAsync(): Promise<boolean> {
        if (Global.IsDevice) {
            /**
             * 进行设备连接
             */
            const flag = await Global.mqttService.ConnectAsync(false);
            `连接状态 ${flag}`.Log("FirstScreen", ColorEnum.Info);
            if (flag) {
                //尝试订阅
                Global.mqttService.InitDeviceSubscribeTopicAsync().then(flag => {
                    if (flag) {
                        //跳转到登录
                        Tools.GoTo("/template", false, {}, {
                            "device_unique_id": Global.DeivceNumber
                        });
                    }
                    else {
                        "设备无订阅数据!".AlertError();
                    }
                });
            }
            return flag;
        }
        else {
            const flag = await Global.mqttService.ConnectAsync(false);
            `连接状态 ${flag}`.Log("FirstScreen", ColorEnum.Info);
            if (flag) {
                Tools.GoTo("/main", false);
            }
            return flag;
        }
    }

    /**
     * 获取当前用户的UserInfo
     */
    public static UserInfo(): ad_account {
        try {
            let {
                header,
                payload,
                signature
            } = Tools.ParseJWT(this.JwtToken.value);
            return payload.UserInfo;
        }
        catch (ex) {
            let errorMessage = "出错了!";
            if (typeof ex == "object") {
                if (ex instanceof Error) {
                    errorMessage = ex?.message ?? '未知';
                }
                else if (typeof ex == "string") {
                    errorMessage = ex;
                }
            }
            Tools.ShowLog("JWTTokenEffective", errorMessage, ColorEnum.Error);

            Tools.GoTo("/", true);
            return {};
        }

    }


    /**
     * 检查JWT是否有效
     */
    private static JWTTokenEffective() {
        try {
            let jwtToken = this.JwtToken.value;
            if (Tools.IsNull(jwtToken))
                return false;
            let {
                header,
                payload,
                signature
            } = Tools.ParseJWT(jwtToken);
            let now = (Tools.GetNowTime / 1000);
            let loginExp = payload.exp - 10; //减去10秒
            if (loginExp <= now)
                return false;
            return true;
        }
        catch (ex) {
            let errorMessage = "出错了!";
            if (typeof ex == "object") {
                if (ex instanceof Error) {
                    errorMessage = ex?.message ?? '未知';
                }
                else if (typeof ex == "string") {
                    errorMessage = ex;
                }
            }
            Tools.ShowLog("JWTTokenEffective", errorMessage, ColorEnum.Error);
        }

    }

    /**
     * JwtToken
     */
    public static get JwtToken(): Ref<string> {
        if (Tools.IsNull(this._jwtToken.value)) {
            let token = localStorage.getItem("AD-JwtToken") ?? "";
            this._jwtToken.value = token;
        }
        return this._jwtToken;
    }

    /**
     * JwtToken
     */
    public static set JwtToken(v: Ref<string>) {
        localStorage.setItem("AD-JwtToken", v.value);
        this._jwtToken.value = v.value;
    }

    /**
     * 刷新Token
     */
    public static get RefreshToken(): Ref<string> {
        if (Tools.IsNull(this._refreshToken.value)) {
            let token = localStorage.getItem("AD-RefreshToken") ?? "";
            this._refreshToken.value = token;
        }
        return this._refreshToken;
    }
    /**
     * 设置刷新Token
     */
    public static set RefreshToken(v: Ref<string>) {
        localStorage.setItem("AD-RefreshToken", v.value);
        this._refreshToken.value = v.value;
    }

    /**
     * 登录账号
     * @param account 
     * @param password 
     */
    public static async LoginAsync(account: string, password: string) {

        let resp = await this.api.globalApi.LoginAsync({
            account: account,
            password: password
        });


        if (resp.CheckIsOk()) {
            let { accessToken, refreshToken } = resp.Data!;
            Global.JwtToken = ref(accessToken);
            Global.RefreshToken = ref(refreshToken);

            return true;
        }
        return false;
    }

    /**
     * 刷新登录ToKen
     * @param force 是否强制刷新
     * @returns 
     */
    public static async ToRefreshTokenAsync(force: boolean = false): Promise<boolean> {

        if (!Global.JWTTokenEffective() || force) {
            let resp = await this.api.globalApi.RefreshTokenAsync({
                RefreshToken: this.RefreshToken.value
            })
            if (resp.CheckIsOk(false)) {
                let {
                    accessToken,
                    refreshToken,
                    invalid
                } = resp.Data!;
                if (invalid == true) {
                    return false;
                }
                else {
                    Global.JwtToken = ref(accessToken);
                    Global.RefreshToken = ref(refreshToken);
                }

                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }

    }

    /**
     * 获取资源URL地址
     * @param url 
     * @param useProxy 是否使用服务器代理
     */
    public static GetResourceURL(url: string | null | undefined, useProxy: boolean = false): string {
        if (Tools.IsNull(url))
            return '';
        if (url == null)
            return '';
        if (url.startsWith("file://"))
            return url;
        if (url.startsWith(`/${Config.MinioUseBucketName}/`))
            return `${Config.MinioResourceURL}/${Config.MinioUseBucketName}${url}`;
        if (url.startsWith("blob:"))
            return url;
        if (url.startsWith("data:"))
            return url;
        if (url.startsWith("http")) {
            if (useProxy)
                url = `${Config.API_HOST}Global/OnlineResourceProxy?url=${encodeURI(url)}`;
            return url;
        }


        if (Config.ResourceFileHost.endsWith('/')) {
            if (url.startsWith('/')) {
                url = url.substring(1);
            }
        }
        else {
            if (!url.startsWith('/')) {
                url = `/${url}`;
            }
        }
        return `${Config.ResourceFileHost}${url}`;
    }


    /**
     * 获取资源唯一标识符
     * @param resource 
     * @returns 
     */
    public static GetResourceKey(resource: ad_resources) {
        return `${resource.unique_identifier}_${resource.resource_index}`;
    }

    /**
     * 加载字体
     */
    public static async LoadFontFamilyAsync(fontResource: ad_resources) {
        const fontResourceKey = this.GetResourceKey(fontResource);
        const fontsLoaded = Array.from(document.fonts).find(f => f.family == fontResourceKey);
        if (!fontsLoaded) {
            //检查当前字体是否存在
            let fontFace = new FontFace(fontResourceKey, `url(${Global.GetResourceURL(fontResource!.resource_link)})`);
            //进行字体加载
            const loadedFont = await fontFace.load();
            globalThis.document.fonts.add(loadedFont);
        }
    }
    /**
     * 显示
     * @param title 
     * @param _buttonMenus 
     */
    public static ShowGuide(title: string, _buttonMenus: GuideMenuButtonVO[]) {
        const fun = Tools.GetAppFun(Global.app!.guideControlRef!, "Show");
        fun && fun(title, _buttonMenus)
    }

    /**
     * 隐藏
     */
    public static HideGuide() {
        const fun = Tools.GetAppFun(Global.app!.guideControlRef!, "Hide");
        fun && fun();
    }

}